module.exports = __webpack_public_path__ + "img/aston-villa.41b25a88.png";